import router from "@/router.ts";
export const openCouponPopup = coupon => {
  localStorage.setItem(
    "opened-coupon",
    JSON.stringify({
      name: "coupon",
      data: coupon,
      redirect: router.currentRoute.path
    })
  );
  setTimeout(() => window.open(coupon.url, "_self"), 100);
  window.open(location.href, "_blank");
};
